import { CaySam, CaySamNhatKy } from 'src/types/caysam';
import { LoSamCamera } from 'src/types/camera';
import { ApiResponse } from '../types/api-response';
import { apiGet, apiPost } from './api-client';

// ----------------------------------------------------------------------
// TYPE DEFINITIONS
// ----------------------------------------------------------------------

export type AddNhatKyBatchData = {
  Ids: string[];
  NgayGhi: string;
  SoLa?: number;
  DiemSucKhoe?: number;
  TinhTrang?: number;
};

export type AddCaySamData = {
  CaySam: Partial<CaySam>;
  CaySamNhatKy: Partial<CaySamNhatKy>;
};

// ----------------------------------------------------------------------
// CAY SAM API SERVICE
// ----------------------------------------------------------------------

export const caySamApiService = {
  async getCaySam(id: string): Promise<ApiResponse<CaySam>> {
    return apiGet<ApiResponse<any>>(
      `/CaySam/GetNhatKyByCaySamId/${id}`,
      'CaySam',
      'Không thể tải cây sâm'
    );
  },
 async getCaySamByUser(): Promise<ApiResponse<CaySam>> {
    return apiGet<ApiResponse<CaySam>>(
      `/CaySam/ListCaySamByUser`,
      'CaySam',  
      'Không thể tải cây sâm'
    );
  },
  async getCaySamNhatKy(id: string): Promise<ApiResponse<CaySamNhatKy>> {
    return apiGet<ApiResponse<CaySamNhatKy>>(
      `/CaySam/GetNhatKyByCaySamId/${id}`,
      'CaySam',
      'Không thể tải nhật ký cây sâm'
    );
  },

  async AddNhatKyByCaySamIds(
    data: AddNhatKyBatchData,
    files: File[] = []
  ): Promise<ApiResponse<any>> {
    const formData = new FormData();
    formData.append('modelJson', JSON.stringify(data));
    
    files.forEach((file) => {
      formData.append('files', file);
    });

    return apiPost<ApiResponse<any>>(
      '/CaySam/AddNhatKyByCaySamIds',
      formData,
      'CaySam',
      true,
      'Không thể thêm nhật ký cây sâm'
    );
  },

  async addCaySam(
    data: AddCaySamData,
    files: File[] = []
  ): Promise<ApiResponse<any>> {
    const formData = new FormData();
    formData.append('modelJson', JSON.stringify(data));
    
    files.forEach((file) => {
      formData.append('files', file);
    });

    return apiPost<ApiResponse<any>>(
      '/CaySam/AddCaySam',
      formData,
      'CaySam',
      true,
      'Không thể thêm cây sâm'
    );
  },

  async addNhatKyByCaySamId(
    data: {
      CaySamId: string;
      NgayGhi: string;
      SoLa: number;
      DiemSucKhoe: number;
      TinhTrang: number;
    },
    files: File[] = []
  ): Promise<ApiResponse<CaySamNhatKy>> {
    const formData = new FormData();
    formData.append('modelJson', JSON.stringify(data));
    
    files.forEach((file) => {
      formData.append('files', file);
    });

    return apiPost<ApiResponse<CaySamNhatKy>>(
      '/CaySam/AddNhatKyByCaySamId',
      formData,
      'CaySam',
      true,
      'Không thể thêm/cập nhật nhật ký cây sâm'
    );
  },

  async editNhatKyByCaySamId(
    data: {
      CaySamId: string;
      NgayGhi: string;
      SoLa: number;
      DiemSucKhoe: number;
      TinhTrang: number;
      IsThongBao: boolean;
      GhiChu: string;
    },
    files: File[] = []
  ): Promise<ApiResponse<CaySamNhatKy>> {
    const formData = new FormData();
    formData.append('modelJson', JSON.stringify(data));
    
    files.forEach((file) => {
      formData.append('files', file);
    });
    return apiPost<ApiResponse<CaySamNhatKy>>(
      '/CaySam/EditNhatKyByCaySamId',
      formData,
      'CaySam',
      true,
      'Không thể thêm/cập nhật nhật ký cây sâm'
    );
  },

  async startStreamCamera(cameraData: {
    id: number;
    loSamId: number;
    loSamLoaiCameraId: number;
    rtsp: string;
    userName: string;
    password: string;
    trangThai: number;
  }): Promise<any> {
    return apiPost<any>(
      '/Camera/StartStreamCamera',
      cameraData,
      'Camera',
      false,
      'Không thể khởi động camera'
    );
  },

  async moveCamera(cameraData: {
    id: number;
    loSamId: number;
    loSamLoaiCameraId: number;
    rtsp: string;
    userName: string;
    password: string;
    trangThai: number;
    action:string;
  }): Promise<any> {
    return apiPost<any>(
      '/Camera/move',
      cameraData,
      'Camera',
      false,
      'Không thể khởi động camera'
    );
  },

async AddDinhKemFileCaySam(
    fileData: {
      CaySam_IDs: string[];
    },
    file: File
  ): Promise<ApiResponse<CaySam>> {
    const formData = new FormData();

    formData.append('modelJson', JSON.stringify(fileData));

    formData.append('file', file);

    return apiPost<ApiResponse<CaySam>>(
      '/CaySam/AddDinhKemFileCaySam', 
      formData,
      'CaySam',
      true, 
      'Không thể thêm tệp đính kèm cho cây sâm'
    );
  },

  async getCaySamByNFC(id: string): Promise<ApiResponse<CaySam>> {
    // Note: This endpoint doesn't require authentication based on original code
    return apiGet<ApiResponse<any>>(
      `/Home/GetThongTinCaySamById/${id}`,
      undefined, // No controller for public endpoint
      'Không thể tải cây sâm'
    );
  },

async OptionCameraByLoSamAndUser(id:string): Promise<ApiResponse<LoSamCamera>>{
  return apiGet<ApiResponse<LoSamCamera>>(
      `/CaySam/OptionCameraByLoSamAndUser?LoSamId=${id}`,
      'CaySam', // No controller for public endpoint
      'Không thể tải cây sâm'
    );
}
};

export default caySamApiService;